import { useSession } from '../../session';

/**
 * Drivers no longer use the app: the fleet sends each indent's code and QR on
 * WhatsApp or SMS. Older driver accounts land here.
 */
export function DriverNotice() {
  const { logout } = useSession();
  return (
    <div className="card stack" style={{ maxWidth: 520 }}>
      <h1>Drivers do not need the app</h1>
      <p>Your fleet manager sends you the fuel code and QR on WhatsApp or SMS. Show it to the pump attendant.</p>
      <p className="muted">The pump may send you a 6-digit SMS code after filling. Tell it to the attendant to confirm the fuel.</p>
      <button className="btn" onClick={() => void logout()}>Sign out</button>
    </div>
  );
}
